import api from 'api/api';
import { IGetUssdSessionsReturn, ISearchUssdSessionsBody } from './UssdSession.model';

export const getUssdSessions = (body: ISearchUssdSessionsBody) => {
  const { startDate, endDate, phoneNumber, pageNumber, pageSize } = body;

  return api.get<unknown, IGetUssdSessionsReturn>('ussd-sessions/search', {
    params: {
      from: startDate,
      to: endDate,
      phoneNumber,
      pageNumber,
      pageSize,
    },
  });
};
